module.exports = __webpack_public_path__ + "static/media/email-settings.ca07a971.png";